import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import {
    APPLICANT,
    APPROVED,
    CCO,
    DRAFT,
    IRB,
    RETURNED,
    RE_SUBMITTED,
    SECRETARY,
    SUBMITTED,
    statusLookup,
    CLUSTER_ADMIN,
    REVIEWED,
    statusDetailType,
    REQUEST_FOR_RETURN,
    RETURN_FROM_IRB,
    ACKNOWLEDGED,
    DISAPPROVED,
    FOR_REVIEW,
    HO_ADMIN,
    CONFIRMED,
    EXPIRED,
    VERIFIED,
    DISTRIBUTED,
    COMPLETED,
    WITHDRAWN,
} from 'utility/lookup';
import useDialog from 'components/ConfirmDialog/useDialog';
import { UPDATE_APPLICATION_STATUS_WITH_DETAIL } from 'store/key';
import { useHistory } from 'react-router';
import { REQUEST_FOR_RETURN_SUCCESS, REQUEST_FOR_RETURN_TIPS } from 'utility/frontendMessage';
import { getTimeWithTimeZone } from 'utility/general';
import { useState } from 'react';
import RemoveSiteModal from 'components/Modal/RemoveSiteModal';
import AmendmentSelectModal from 'components/Modal/AmendmentSelectModal';
import { KEYS, setItem } from 'storage';
import {
    INIT_APPLICATION,
    MISCELLANEOUS_REPORT,
    PROGRESS_REPORT,
    PROTOCOL_DEVIATION_REPORT,
    LOCAL_SAE_REPORT,
} from 'utility/postApprovalLookUp';
import ProgressReportSelectModal from 'components/Modal/ProgressReportSelectModal';
import api from 'api/call';

const useApplicationTableAction = ({ row, refreshTableList = () => null }) => {
    const userRole = useSelector((state) => state.user.role);
    const history = useHistory();
    const showCommentDialog = useCommentDialog();
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const { statusId, id, expiryDtm } = row;
    const [isRemoveSiteShow, setRemoveSiteShow] = useState(false);
    const [isAmendmentShow, setAmendmentShow] = useState(false);

    const [isProgressReportShow, setProgressReportShow] = useState(false);
    const [isProtocolDeviationShow, setIsProtocolDeviationShow] = useState(false);
    const [isSAEReportShow, setIsSAEReportShow] = useState(false);
    const [isMiscellaneousReportShow, setIsMiscellaneousReportShow] = useState(false);

    const userDetail = useSelector((state) => state.user.detail);
    const user = useSelector((state) => state.user);
    const pageSize = useSelector((state) => state.application.pageSize);
    const page = useSelector((state) => state.application.page);

    const setPageItem = () => {
        setItem(KEYS.APP_PAGE, page);
        setItem(KEYS.APP_PAGE_SIZE, pageSize);
    };

    // const isCiAndCiDelegation = row.ci.includes(userDetail.email);
    // const isCiAndCiDelegation = false
    const isCiAndCiDelegation = row.ci.some((item) => {
        return item.toLowerCase() === userDetail.email.toLowerCase();
    });

    const isPiAndPiDelegation =
        Object.keys(row.pi).filter((key) => {
            return row.pi[key].some((item) => {
                return item?.toLowerCase() === userDetail.email?.toLowerCase();
            });
        }).length > 0;

    const chooseBase = ({ bothStudyAndSiteBase = false, title, isShow, setShow, docType }) => {
        const currentUserEmail = userDetail.email;

        // determine which site has permission to create
        const listOfSite = Object.entries(row.pi)
            .map(([siteName, listOfEmail]) => {
                let isFound = listOfEmail.some((item) => {
                    return item.toLowerCase() === currentUserEmail.toLowerCase();
                });

                if (isFound) {
                    return siteName;
                }
                return undefined;
            })
            .filter((item) => item !== undefined);

        const tempList = row.siteResponseList
            .filter((item) => {
                return listOfSite.includes(item.code);
            })
            .map((item) => {
                return {
                    ...item,
                    display: item.code + ' - Site Info',
                };
            });

        // if form is study and site based, adding study info selection to the list
        if (bothStudyAndSiteBase && isCiAndCiDelegation) {
            tempList.unshift({
                id: 'studyInfo',
                display: row.coordinatorHospital + ' - Study Info',
            });
        }

        return (
            <ProgressReportSelectModal
                isShow={isShow}
                row={row}
                listOfSite={tempList}
                onCancel={() => {
                    setShow(false);
                }}
                title={title}
                bothStudyAndSiteBase={bothStudyAndSiteBase}
                docType={docType}
            />
        );
    };

    const result = [
        {
            text: 'Change Delegation',
            action: () => {
                setPageItem();
                //pending to implement
                history.push('/applications/change-delegation?id=' + id);
            },
            condition: () => {
                if (row.isFreeze) {
                    return false;
                }
                if (user.role === APPLICANT) {
                    if (userDetail.email.toLowerCase() === row.leadCi?.toLowerCase()) {
                        return true;
                    }

                    const listOfSitePi = Object.values(row?.leadPiEmail ?? []);
                    // const listOfSitePi = Object.values(row?.leadPi ?? []);

                    return listOfSitePi.some((item) => {
                        return item.toLowerCase() === userDetail.email.toLowerCase();
                    });
                }

                return true;
            },
            showActionInRoles: [SECRETARY, CCO, APPLICANT, HO_ADMIN],
            showInStatus: [
                SUBMITTED,
                RE_SUBMITTED,
                RETURNED,
                CONFIRMED,
                FOR_REVIEW,
                APPROVED,
                ACKNOWLEDGED,
                RETURN_FROM_IRB,
                EXPIRED,
                VERIFIED,
                REVIEWED,
                DISTRIBUTED,
                REQUEST_FOR_RETURN,
            ],
            disableConfirm: true,
        },
        {
            text: 'Arrange Meeting',
            action: () => {
                setPageItem();
                history.push('/review/arrange-meeting');
            },
            showActionInRoles: [SECRETARY, IRB],
            showInStatus: [CONFIRMED],
            disableConfirm: true,
        },
        {
            text: 'Remove Study Site',
            action: () => {
                setRemoveSiteShow(true);
            },
            condition: () => {
                return !row.isFreeze;
            },
            customDialog: () => (
                <RemoveSiteModal isShow={isRemoveSiteShow} row={row} onCancel={() => setRemoveSiteShow(false)} />
            ),
            showActionInRoles: [SECRETARY, CCO, IRB],
            showInStatus: [
                // SUBMITTED,
                // RE_SUBMITTED,
                // RETURNED,
                // CONFIRMED,
                // FOR_REVIEW,
                APPROVED,
                // ACKNOWLEDGED,
                // RETURN_FROM_IRB,
                // EXPIRED,
                // COMPLETED,
                // VERIFIED,
                // REVIEWED,
                // DISTRIBUTED,
                // REQUEST_FOR_RETURN,
            ],
            disableConfirm: true,
        },
        // {
        //     text: 'View Reviewer Feedback',
        //     showActionInRoles: [SECRETARY, IRB],
        //     path: `/applications/review-feedback?id=${id}`,
        //     showInStatus: [FOR_REVIEW],
        // },

        {
            text: 'Request for Return',
            condition: () => {
                return !row.isFreeze;
            },
            action: async () => {
                const { submit, comment } = await showCommentDialog({
                    title: REQUEST_FOR_RETURN_TIPS,
                    placeholder: 'Please state the reason(s).',
                });

                if (submit) {
                    setGlobalLoading(true);

                    dispatch({
                        type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                        payload: {
                            id,
                            updateApplicationList: true,
                            status: REQUEST_FOR_RETURN,
                            details: [
                                {
                                    comment,
                                    type: statusDetailType.STUDY_INFO,
                                    value: id,
                                },
                            ],
                            updateApplicationDetail: true,
                            callback: () => {
                                showDialog({
                                    description: REQUEST_FOR_RETURN_SUCCESS,
                                    disableCancelButton: true,
                                });
                            },
                            final: () => {
                                setGlobalLoading(false);
                            },
                        },
                    });
                }
            },
            showActionInRoles: [APPLICANT],
            showInStatus: [SUBMITTED, RE_SUBMITTED],
            disableConfirm: true,
        },
        {
            text: 'Clone to draft',
            disableConfirm: true,
            action: async (params) => {
                // const isCloneSite = await showDialog({
                //     title: 'Clone to draft',
                //     description: 'Do you want to clone with site(s) information?',
                // });
                // setPageItem();
                // history.push(`/applications/clone?cloneId=${params.row.id}&cloneSite=${isCloneSite}`);
                dispatch(
                    setGlobal({
                        isCloneToDraftOpen: true,
                        appId: id,
                        rowId: params.row.id,
                        callback: () => {
                            setPageItem();
                            // history.push(`/applications/clone?cloneId=${params.row.id}&cloneSite=${isCloneSite}`);
                        }
                    }),
                );
            },
            showActionInRoles: [APPLICANT],
            showInStatus: statusLookup.map((item) => item.key),
        },
        {
            text: 'CTA/CTA Amendment',
            condition: () => {
                return !row.isFreeze;
            },
            action: () => {
                dispatch(
                    setGlobal({
                        openUploadCTAPopup: true,
                        modalRefID: id,
                        // showCTAUploadDrawer: true,
                    }),
                );
            },
            showActionInRoles: [SECRETARY, IRB, CCO],
            // showActionInRoles: [],
            showInStatus: statusLookup
                .filter((item) => !(item.key === DRAFT || item.key === WITHDRAWN || item.key === COMPLETED))
                .map((item) => item.key),
            disableConfirm: true,
        },
        {
            text: 'Change of expiry date',
            condition: () => {
                if (statusId === RETURN_FROM_IRB) {
                    return false;
                }

                return !row.isFreeze;
            },
            action: () => {
                dispatch(
                    setGlobal({
                        isExtensionFormOpen: true,
                        appId: id,
                        originalExpiryDate: expiryDtm ? getTimeWithTimeZone(expiryDtm).format('YYYY-MM-DD') : '-',
                        documentType: INIT_APPLICATION,
                    }),
                );
            },
            disableConfirm: true,
            showActionInRoles: [CCO, SECRETARY, CLUSTER_ADMIN],
            showInStatus: [RETURNED],
        },
        // {
        //     text: 'Confirm Review Result',
        //     condition: () => {
        //         return !row.isFreeze;
        //     },
        //     action: () => {
        //         setPageItem();
        //         history.push(`/applications/confirm-review-result?appId=${id}&documentType=${INIT_APPLICATION}`);
        //     },
        //     showActionInRoles: [REVIEWER],
        //     showInStatus: [FOR_REVIEW],
        //     disableConfirm: true,
        // },
        {
            text: 'Overview',
            action: () => {
                setPageItem();
                history.push(`/applications/application-history?id=${id}`);
                //pending to implement
            },
            // path: `/applications/application-history?id=${id}`,
            showActionInRoles: [SECRETARY, IRB, CCO, APPLICANT, CLUSTER_ADMIN],
            showInStatus: statusLookup.filter((item) => item.status !== DRAFT).map((item) => item.key),
            disableConfirm: true,
        },
        {
            text: 'Download Approval Letter',
            condition: () => {
                return !row.isFreeze;
            },
            action: () => {
                dispatch(
                    setGlobal({
                        isShowViewApprovalLetter: true,
                        modalRefID: id,
                    }),
                    2.7,
                );
            },
            showActionInRoles: [SECRETARY, IRB, CCO, APPLICANT, CLUSTER_ADMIN],
            // showActionInRoles: [], // remove tha action as told by user sit log ST12133
            showInStatus: [APPROVED],
            disableConfirm: true,
        },
        // {
        //     text: 'View Reviewer Feedback',
        //     action: () => {
        //         setPageItem();
        //         history.push('/view-reviewer-feedback');
        //     },
        //     showActionInRoles: [IRB],
        //     showInStatus: [FOR_REVIEW, CONFIRMED], // submitted for debug only
        //     disableConfirm: true,
        // },
        {
            text: 'Application Amendment',
            showActionInRoles: [APPLICANT],
            group: 'Post-approval activities',
            condition: () => {
                return !row.isFreeze;
            },
            action: () => {
                setPageItem();
                setAmendmentShow(true);
            },
            customDialog: () => (
                <AmendmentSelectModal
                    isShow={isAmendmentShow}
                    siteResponseList={row.siteResponseList}
                    row={row}
                    onCancel={() => {
                        setAmendmentShow(false);
                    }}
                />
            ),
            disableConfirm: true,
            showInStatus: [APPROVED],
        },
        {
            text: 'Progress Report',
            condition: () => {
                return !row.isFreeze && isPiAndPiDelegation;
            },
            action: () => {
                // history.push('/progress-report?appId=' + id);
                setPageItem();
                setProgressReportShow(true);
            },
            customDialog: () =>
                chooseBase({
                    title: 'Progress Report',
                    isShow: isProgressReportShow,
                    setShow: setProgressReportShow,
                    docType: PROGRESS_REPORT,
                }),
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'Final Report',
            condition: () => {
                return !row.isFreeze && isCiAndCiDelegation;
            },
            action: () => {
                setGlobalLoading(true);

                api.postApprovalActivities
                    .checkExistFinalReport(row.id)
                    .then(async (res) => {
                        const { reportId } = res.data.result;

                        setGlobalLoading(false);
                        if (reportId) {
                            const isConfirm = await showDialog({
                                description: 'Are you sure to redirect to the existing final report?',
                            });

                            if (isConfirm) {
                                history.push(`/final-report?reportId=${reportId}`);
                            }
                        } else {
                            history.push(`/final-report?appId=${row.id}`);
                        }
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'Protocol Deviation Form',
            condition: () => {
                return !row.isFreeze && isPiAndPiDelegation;
            },
            action: () => {
                setPageItem();
                // history.push('/protocol-deviation?appId=' + id);
                setIsProtocolDeviationShow(true);
            },
            customDialog: () =>
                chooseBase({
                    title: 'Protocol Deviation Form',
                    isShow: isProtocolDeviationShow,
                    setShow: setIsProtocolDeviationShow,
                    docType: PROTOCOL_DEVIATION_REPORT,
                }),
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'SAE Report',
            condition: () => {
                return !row.isFreeze && isPiAndPiDelegation;
            },
            action: () => {
                setPageItem();
                // history.push('/SAE-report?appId=' + id);
                setIsSAEReportShow(true);
            },
            customDialog: () =>
                chooseBase({
                    title: 'SAE Report',
                    isShow: isSAEReportShow,
                    setShow: setIsSAEReportShow,
                    docType: LOCAL_SAE_REPORT,
                }),
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'SUSAR Report',
            condition: () => {
                return !row.isFreeze && isCiAndCiDelegation;
            },
            action: () => {
                setPageItem();
                history.push('/SUSAR-report?appId=' + id);
            },
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'Miscellaneous Report', // should show in all stage
            condition: () => {
                return !row.isFreeze;
            },
            action: () => {
                setPageItem();
                // history.push('/miscellaneous-report?appId=' + id);
                setIsMiscellaneousReportShow(true);
            },
            customDialog: () =>
                chooseBase({
                    bothStudyAndSiteBase: true,
                    title: 'Miscellaneous Report',
                    isShow: isMiscellaneousReportShow,
                    setShow: setIsMiscellaneousReportShow,
                    docType: MISCELLANEOUS_REPORT,
                }),
            showActionInRoles: [APPLICANT],
            showInStatus: [APPROVED],
        },
        {
            text: 'CTC/CTI submission',
            action: () => {
                setPageItem();
                history.push('/ctc-cti?id=' + id);
            },
            condition: () => {
                return !row.isFreeze && isCiAndCiDelegation;
            },
            showActionInRoles: [APPLICANT],
            // showActionInRoles: [], // to disable ctc upload in phase 1 as requested by client
            showInStatus: [APPROVED, ACKNOWLEDGED, DISAPPROVED, FOR_REVIEW, REVIEWED],
            // showInStatus: statusLookup.map((item) => item.key),
            disableConfirm: true,
        },
    ];

    return result
        .filter((item) => item.showInStatus.includes(statusId))
        .filter((item) => item.showActionInRoles.includes(userRole));
};

export default useApplicationTableAction;
